// freeShippingProgress.js
export function initFreeShippingProgress() {
	const wrap = document.getElementById("js-free-shipping");
	if (!wrap) return;

	const threshold = parseInt(wrap.dataset.threshold, 10);
	if (!Number.isFinite(threshold) || threshold <= 0) return;

	const elRemainingWrap = wrap.querySelector("[data-remaining-wrap]");
	const elReachedWrap = wrap.querySelector("[data-reached-wrap]");
	const elRemainingAmount = wrap.querySelector("[data-remaining-amount]");
	const elBarFill = wrap.querySelector("[data-bar-fill]");

	// Util per formattare denaro come fai già in cartForm.js
	function formatMoney(cents) {
		try {
			if (
				window.Shopify &&
				typeof window.Shopify.formatMoney === "function"
			) {
				const moneyFormat =
					(window.theme && window.theme.moneyFormat) ||
					window.Shopify.money_format ||
					"{{amount}}";
				return window.Shopify.formatMoney(cents, moneyFormat);
			}
		} catch (e) {}
		const n = (cents / 100).toFixed(2);
		return `${n.replace(".", ",")} €`;
	}

	function updateFromCart(cart) {
		if (!cart || typeof cart.total_price !== "number") return;

		const total = cart.total_price; // in centesimi
		const amountLeft = Math.max(0, threshold - total);
		let progress = Math.floor((total * 100) / threshold);
		if (progress > 100) progress = 100;

		// Messaggi
		if (amountLeft > 0) {
			if (elRemainingWrap) elRemainingWrap.style.display = "";
			if (elReachedWrap) elReachedWrap.style.display = "none";
			if (elRemainingAmount)
				elRemainingAmount.textContent = formatMoney(amountLeft);
		} else {
			if (elRemainingWrap) elRemainingWrap.style.display = "none";
			if (elReachedWrap) elReachedWrap.style.display = "";
		}

		// Barra
		if (elBarFill) elBarFill.style.width = `${progress}%`;
	}

	// 1) Aggiorna subito con lo stato attuale del carrello (se disponibile)
	//    Se non hai un cart globale, fai una chiamata leggera.
	fetch("/cart.js")
		.then((r) => r.json())
		.then(updateFromCart)
		.catch(() => {});

	// 2) Ascolta gli aggiornamenti
	document.addEventListener("cart:updated", (ev) => {
		const cart = ev?.detail?.cart;
		if (cart) updateFromCart(cart);
		else {
			// fallback in caso l'evento non porti il payload
			fetch("/cart.js")
				.then((r) => r.json())
				.then(updateFromCart)
				.catch(() => {});
		}
	});
}
